<template>
	<div :class="fieldClasses">
		<h5 v-if="label" :class="bemm('label')">{{ label }}</h5>
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { FormGroupDirection } from './FormGroup.model';
import { useBemm } from 'bemm';

defineOptions({
	name: 'FormField',
});

const props = withDefaults(
	defineProps<{
		direction?: FormGroupDirection;
		label?: string;
	}>(),
	{
		direction: FormGroupDirection.VERTICAL,
		label: '',
	}
);
const { label } = toRefs(props);

const bemm = useBemm('ar-form-group', {
	return: 'string',
	includeBaseClass: true,
});

const fieldClasses = computed(() => bemm('', [props.direction]));
</script>

<style lang="scss">
.ar-form-group {
	display: flex;
	flex-direction: column;
	gap: var(--space);

	width: 100%;
	max-width: var(--form-group-max-width, 720px);
	margin-inline: auto;
}
</style>
